/**
 * Shared "has the user seen this module's tour?" flag storage.
 *
 * One localStorage object per user (keyed by the stable JWT sb_user_unique_id)
 * holds every module's flag together, instead of a separate key per tour:
 *
 *   sb-tour-seen:<sbUserUniqueId>  →  { "jobs-library": true, "skills-bridger": true }
 *
 * Usage from a module's tour:
 *   if (!isTourSeen(userId, "jobs-library")) startTour();
 *   markTourSeen(userId, "jobs-library");   // on finish/dismiss
 *
 * localStorage per device. To make it cross-device later, swap these two helpers
 * for a backend field on the user record — call sites stay the same.
 */

const keyForUser = (userId) => `sb-tour-seen:${userId}`;

const readForUser = (userId) => {
  try {
    return JSON.parse(localStorage.getItem(keyForUser(userId))) || {};
  } catch {
    return {};
  }
};

export const isTourSeen = (userId, moduleKey) =>
  !!userId && readForUser(userId)[moduleKey] === true;

export const markTourSeen = (userId, moduleKey) => {
  if (!userId) return;
  try {
    const seen = readForUser(userId);
    seen[moduleKey] = true;
    localStorage.setItem(keyForUser(userId), JSON.stringify(seen));
  } catch {
    /* storage unavailable — ignore */
  }
};
